import { BehaviorSubject, Observable, of } from 'rxjs';
import { GetMyGamesResponse } from '@core-http';

const INITIAL_STATE: GetMyGamesResponse = {
  host: [],
  player: { approved: [], waiting: [], invitations: [], moderated: [] }
};

export class MyGamesStorage {
  private readonly subject: BehaviorSubject<GetMyGamesResponse> = new BehaviorSubject<GetMyGamesResponse>(
    INITIAL_STATE
  );
  private readonly loadedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  readonly games$: Observable<GetMyGamesResponse> = this.subject.asObservable();
  readonly loaded$: Observable<boolean> = this.loadedSubject.asObservable();

  setContext(dto: GetMyGamesResponse): Observable<void> {
    this.subject.next(dto);
    this.loadedSubject.next(true);
    return of(void 0);
  }
}
